import { Injectable } from "@angular/core";
import { HelperService } from "../shared/services/helper.service";
import { environment } from "../../environments/environment";
import { HttpService } from "../shared/services/http.service";
import {
    GiftCardOrderSalesModel, GiftCardVirtualsModel,
    GiftCardClientsModel, GiftCardContactModel, GiftCardTypesModel,
    GiftCardGroupModel, GiftCardModel
} from "../models/gifcardVirtual.model";


@Injectable()
export class GifcardTiendaService {
    private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
    private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
    private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
    private URL: string;
    public TYPE_ORDER_SALES_TIENDA= "T";

    constructor(private httpService: HttpService) { }

    public GetGiftCardOrderSalesTienda() {
        this.URL = `${this.REQUEST_URL}/getOrderSalesTienda`;
        return this.httpService.get<GiftCardOrderSalesModel[]>(this.URL);
    }    

    public GetOrderSalesTiendaByStatus(params) {
        this.URL = `${this.REQUEST_URL}/getOrderSalesTiendaByStatus`;
        return this.httpService.post<GiftCardOrderSalesModel[]>(this.URL, params);
    }

    public GetOrderSalesTiendaByStatusAndUser(params) {
        this.URL = `${this.REQUEST_URL}/getOrderSalesTiendaByStatusAndUser`;
        return this.httpService.post<GiftCardOrderSalesModel[]>(this.URL, params);
    }

    public CreateOrderSalesTienda(orderSales) {
        this.URL = `${this.REQUEST_URL}/createOrderSalesTienda`;
        return this.httpService.post<any>(this.URL, orderSales);
    }
    
    public CreateOrderSalesTiendaItem(orderSales) {
        this.URL = `${this.REQUEST_URL}/createOrderSalesTiendaItem`;
        return this.httpService.post<any>(this.URL, orderSales);
    }
    
    public UpdateOrderSalesTiendaStatus(params) {
        this.URL = `${this.REQUEST_URL}/updateOrderSalesTiendaStatus`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateOrderSalesTiendaFacturacion(params) {
        this.URL = `${this.REQUEST_URL}/updateOrderSalesTiendaFacturacion`;
        return this.httpService.put<any>(this.URL, params);
    }

}